const StringUtilities = (module.exports = {})

StringUtilities.hashCode = function(str) {
  if ((str || '').length === 0) return 0
  let value = 0
  for (let i = 0; i < str.length; i++) {
    value += Number(str[i].charCodeAt(0).toString(2))
  }
  return Math.abs(value)
}
